// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_mq-5";
export var filledCircle = "_mq-4";
export var historyEntry = "_mq-3";
export var messageSideLeft = "_mq-1";
export var messageSideRight = "_mq-2";
export var orderTrackingCarouselWrapper = "_mq-6";
export var orderTrackingInfoContainer = "_mq-0";